import { isFunction, forEach, isEmpty } from 'lodash';
import consts from '../consts';

const MapCallbackEvents = {};
const MapRegisEvents = {};
const MapRegisPrivateEvents = {};
let sendMethod;
let sendPrivateMethod;
const WS_CLOSE = 'close';
const WS_OPEN = 'open';

export const InitWSIfNeed = (send) => {
  if (isFunction(send)) {
    sendMethod = send;
  }
};

export const InitPrivateWSIfNeed = (send) => {
  if (isFunction(send)) {
    sendPrivateMethod = send;
  }
};

export const Regis = (event, room = event) => {
  console.log(`Regis === ${room} ===`);
  console.log(`event === ${event} ===`);
  if (!isFunction(sendMethod)) {
    return;
  }

  if (MapRegisEvents[`${event}`]) {
    if (MapRegisEvents[`${event}`].channel !== room) {
      const oldMapRegisEvents = { ...MapRegisEvents[`${event}`] };
      MapRegisEvents[`${event}`].channel = room;
      MapRegisEvents[`${event}`].stack = [oldMapRegisEvents, ...MapRegisEvents[`${event}`].stack];
      sendMethod(MapRegisEvents[`${event}`]);
    }

    MapRegisEvents[`${event}`].count++;
    return;
  }

  MapRegisEvents[`${event}`] = {
    channel: room,
    message: WS_OPEN,
    count: 1,
    stack: [],
  };

  sendMethod(MapRegisEvents[`${event}`]);
};

export const RegisPrivate = (event, room = event, sendWithoutCheck = false) => {
  if (sendWithoutCheck) {
    sendPrivateMethod(MapRegisPrivateEvents[`${event}`]);
    return;
  }

  console.log(`RegisPrivate === ${room} ===`);
  console.log(`event === ${event} ===`);
  if (!isFunction(sendPrivateMethod)) {
    return;
  }
  if (MapRegisPrivateEvents[`${event}`]) {
    if (MapRegisPrivateEvents[`${event}`].channel !== room) {
      const oldMapRegisPrivateEvents = { ...MapRegisPrivateEvents[`${event}`] };
      MapRegisPrivateEvents[`${event}`].channel = room;
      MapRegisPrivateEvents[`${event}`].stack = [oldMapRegisPrivateEvents, ...MapRegisPrivateEvents[`${event}`].stack];
      sendPrivateMethod(MapRegisPrivateEvents[`${event}`]);
    }

    MapRegisPrivateEvents[`${event}`].count++;
    return;
  }

  MapRegisPrivateEvents[`${event}`] = {
    channel: room,
    message: WS_OPEN,
    count: 1,
    stack: [],
  };

  sendPrivateMethod(MapRegisPrivateEvents[`${event}`]);
};

export const UnRegis = (event, force = false) => {
  if (!isFunction(sendMethod)) {
    return;
  }

  if (!MapRegisEvents[`${event}`]) {
    return;
  }

  if (force === true) {
    sendMethod({ ...MapRegisEvents[`${event}`], message: WS_CLOSE });
    delete MapRegisEvents[`${event}`];
    return;
  }

  MapRegisEvents[`${event}`].count--;
  if ((MapRegisEvents[`${event}`].stack || []).length > 0) {
    if (MapRegisEvents[`${event}`].count === 0) {
      MapRegisEvents[`${event}`] = MapRegisEvents[`${event}`].stack[0];
    }
  } else if (MapRegisEvents[`${event}`].count === 0) {
    sendMethod({ ...MapRegisEvents[`${event}`], message: WS_CLOSE });
    delete MapRegisEvents[`${event}`];
  }
  // todo unregis socket
};

export const UnRegisAll = () => {
  if (!isFunction(sendMethod)) {
    return;
  }

  forEach(Object.values(MapRegisEvents), (event) => {
    UnRegis(event, true);
    // delete MapRegisEvents[event];
  });
};

export const UnRegisPrivate = (event, force = false) => {
  if (!isFunction(sendPrivateMethod)) {
    return;
  }
  if (!MapRegisPrivateEvents[`${event}`]) {
    return;
  }

  if (force === true) {
    sendPrivateMethod({ ...MapRegisPrivateEvents[`${event}`], message: WS_CLOSE });
    delete MapRegisPrivateEvents[`${event}`];
    return;
  }

  MapRegisPrivateEvents[`${event}`].count--;
  if ((MapRegisPrivateEvents[`${event}`].stack || []).length > 0) {
    if (MapRegisPrivateEvents[`${event}`].count === 0) {
      MapRegisPrivateEvents[`${event}`] = MapRegisPrivateEvents[`${event}`].stack[0];
    }
  } else if (MapRegisPrivateEvents[`${event}`].count === 0) {
    sendPrivateMethod({ ...MapRegisPrivateEvents[`${event}`], message: WS_CLOSE });
    delete MapRegisPrivateEvents[`${event}`];
  }

  // todo unregis socket
};

export const UnRegisPrivateAll = () => {
  if (!isFunction(sendPrivateMethod)) {
    return;
  }

  forEach(Object.keys(MapRegisPrivateEvents), (event) => {
    UnRegisPrivate(event, true);
  });
};

export const DispatchAction = (params = {}, event) => {
  if (!MapRegisEvents[event]) return;

  if (MapCallbackEvents[event]) {
    Object.values(MapCallbackEvents[event], (callback) => {
      callback(params.data);
    });
  }

  window.dispatch({
    type: event,
    ...params,
  });
};

export const DispatchPrivateAction = (params, event) => {
  if (!MapRegisPrivateEvents[event]) return;

  if (MapCallbackEvents[event]) {
    Object.values(MapCallbackEvents[event], (callback) => {
      callback(...params);
    });
    // forEach(MapCallbackEvents[event], );
  }

  window.dispatch({
    type: event,
    ...params,
  });
};

export const RegisCallback = (callback, event, action) => {
  if (isEmpty(MapCallbackEvents[event])) {
    MapCallbackEvents[event] = {};
  }

  if (isFunction(callback)) {
    MapCallbackEvents[event][action] = callback;
  }
};

export const Reconnect = () => {
  forEach(Object.keys(MapRegisPrivateEvents), (event) => {
    if (event !== consts.WS_EVENT_AUTH) {
      sendPrivateMethod({ ...MapRegisPrivateEvents[`${event}`], message: WS_OPEN });
    }
  });
};

export const ReconnectPublic = () => {
  forEach(Object.keys(MapRegisEvents), (event) => {
    sendMethod({ ...MapRegisEvents[`${event}`], message: WS_OPEN });
  });
};

export default {
  MapRegisPrivateEvents,
  MapRegisEvents,
};
